if (!customElements.get("product-gallery-modal")) {
  customElements.define(
    "product-gallery-modal",
    class ProductGalleryModal extends ModalDialog {
      constructor() {
        super();

        this.slider = this.querySelector("slider-component");
        this.tip = this.querySelector(".modal-tip");
      }

      show(opener) {
        super.show(opener);
        setTimeout(() => this.showActiveMedia(), 50);

        // 显示操作提示
        if (this.timer) clearTimeout(this.timer);
        this.tip.classList.add("active");
        this.timer = setTimeout(() => {
          this.tip.classList.remove("active");
        }, 5000);
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute("data-media-id");
        if (!mediaId) return;

        if (this.slider && this.slider.initSliderStatus) {
          const currentSlideElement = this.slider.querySelector(
            `.slider-slide[data-media-id='${mediaId}']`,
          );
          if (!currentSlideElement) return;

          this.slider.slideByElement(currentSlideElement);

          const deferredMedia =
            currentSlideElement.querySelector(".deferred-media");
          if (deferredMedia) {
            deferredMedia.loadContent();
          }
        }
      }
    },
  );
}

(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function initMobileProductGallery() {
    if (!isMobile()) return;

    const galleries = document.querySelectorAll(
      'ul.product-media-list[id^="Slider-Gallery-"]'
    );

    galleries.forEach(function (gallery) {
      if (gallery.dataset.mobileFadeGallery === 'true') return;

      const slides = Array.from(
        gallery.querySelectorAll(':scope > li.product-media-item')
      );

      if (slides.length < 2) return;

      gallery.dataset.mobileFadeGallery = 'true';
      gallery.classList.add('mobile-fade-gallery-ready');

      let currentIndex = 0;
      let startX = 0;
      let startY = 0;
      let moveX = 0;
      let isHorizontalSwipe = false;
      let isSwiping = false;

      /* 清理旧圆点，避免重复生成 */
      const oldDots = gallery.parentNode.querySelector('.mobile-product-gallery-dots');
      if (oldDots) oldDots.remove();

      const dots = document.createElement('div');
      dots.className = 'mobile-product-gallery-dots';

      function switchSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        currentIndex = index;

        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle(
            'is-mobile-gallery-active',
            slideIndex === currentIndex
          );
        });

        dots.querySelectorAll('.mobile-product-gallery-dot').forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === currentIndex);
        });
      }

      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-mobile-gallery-active', index === 0);

        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mobile-product-gallery-dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', '切换商品图片 ' + (index + 1));

        dot.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          switchSlide(index);
        });

        dots.appendChild(dot);
      });

      /*
        不改 Liquid / HTML 模板：
        JS 自动把圆点插到主图 ul 后面
      */
      gallery.insertAdjacentElement('afterend', dots);

      gallery.addEventListener(
        'touchstart',
        function (event) {
          if (!isMobile()) return;

          const touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          moveX = 0;
          isHorizontalSwipe = false;
          isSwiping = false;
        },
        {
          passive: true,
          capture: true
        }
      );

      gallery.addEventListener(
        'touchmove',
        function (event) {
          if (!isMobile()) return;

          const touch = event.touches[0];
          const diffX = touch.clientX - startX;
          const diffY = touch.clientY - startY;

          moveX = diffX;

          /*
            判断为横向滑动：
            1. 当前商品图切换
            2. 阻止主题原 slider 带动旁边图片
          */
          if (Math.abs(diffX) > 10 && Math.abs(diffX) > Math.abs(diffY)) {
            isHorizontalSwipe = true;
            isSwiping = true;

            event.preventDefault();
            event.stopPropagation();
          }
        },
        {
          passive: false,
          capture: true
        }
      );

      gallery.addEventListener(
        'touchend',
        function (event) {
          if (!isMobile()) return;
          if (!isHorizontalSwipe) return;
          if (Math.abs(moveX) < 40) return;

          event.preventDefault();
          event.stopPropagation();

          if (moveX < 0) {
            switchSlide(currentIndex + 1);
          } else {
            switchSlide(currentIndex - 1);
          }

          setTimeout(function () {
            isSwiping = false;
            isHorizontalSwipe = false;
            moveX = 0;
          }, 180);
        },
        {
          passive: false,
          capture: true
        }
      );

      /*
        防止滑动后误触放大弹窗 / 链接
      */
      gallery.addEventListener(
        'click',
        function (event) {
          if (!isMobile()) return;

          if (isSwiping || Math.abs(moveX) >= 40) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        {
          capture: true
        }
      );
    });
  }

  document.addEventListener('DOMContentLoaded', initMobileProductGallery);
  document.addEventListener('shopify:section:load', initMobileProductGallery);

  setTimeout(initMobileProductGallery, 500);
  setTimeout(initMobileProductGallery, 1500);
  setTimeout(initMobileProductGallery, 3000);
})();
